/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
import { useCurrentEditor } from "@tiptap/react";
import { isGuid } from "utils/empty-exists";
import { DocumentSelector } from "cms/documents/document-selector";
import { useUpdateDocument } from "cms/rich-text/simplicity-composer-tiptap/document/use-update-document";
import { DocumentDisplay } from "cms/rich-text/simplicity-composer-tiptap/document/document-display";
import { Logger } from "cms/utils/log/logger";

const DocumentSettingsDialog = () => {

    const markType = "doclink";
    const {
        doclink,
        updateDocLink,
    } = useUpdateDocument();
    const { editor } = useCurrentEditor();

    const setDocument = () => {};
    const onChooseDocumentHandler = (docLink) => {
        Logger.debug("Document Chosen", docLink);
        updateDocLink(docLink);
    };
    const updateRichText = (document) => {
        const docLink = {
            title: document?.link_text ? document?.link_text : document?.title,
            text: document?.link_text ? document?.link_text : document?.title,
            href: document?.url,
            url: document?.url,
            type: "doclink",
            guid: document.guid,
            target: "_blank",
        };
        updateDocLink(docLink);
    };
    const onSaveDocumentHandler = (document) => {
        Logger.debug("Document Saved", document);
        editor.chain().focus().extendMarkRange(markType);
        updateRichText(document);
    };
    const onSelectDocument = (docLink) => {
        Logger.debug("Document Selected", docLink);
        updateRichText(docLink);
    };
    const onRemoveDocument = () => {
        editor.chain().focus().extendMarkRange(markType).unsetLink().run();
        // editor.commands.setNode("paragraph", {})
    };
    const handleClose = (event) => {
        if (event) {
            event.stopPropagation();
        }
        const { guid } = doclink || {};
        if (!isGuid(guid)) {
            editor.chain().focus().extendMarkRange(markType).unsetLink().run();
            editor.commands.setNode("paragraph", {});
            editor.chain().focus().selectTextblockEnd( ).run();
        }
    };

    return (
        <Fragment>
            <DocumentSelector
                docLink={doclink}
                setDocument={setDocument}
                onSelectDocumentHandler={onSelectDocument}
                onSaveDocumentHandler={onSaveDocumentHandler}
                onChooseDocumentHandler={onChooseDocumentHandler}
                onDocumentRemoved={onRemoveDocument}
                // The buttons in the bubble menu are found inside DocumentDisplay
                // these need to be callable from the within the DocumentSelector
                DisplayComponent={DocumentDisplay}
                AddComponent={DocumentDisplay}
                handleCancel={handleClose}
            />
        </Fragment>
    );
};

export { DocumentSettingsDialog };
